export default __webpack_public_path__ + "locales/lv/ChangePasswordDialog.json?hash=904a89518db654e9a8590ad41de642b2";